import { DatePipe } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { ICurationItem } from '../../interfaces/curation-item.interface';
import { CurationUtils } from '../../utils/curation-utils';
import { CurationSettings } from '../curation-dashboard/curation-setting';

@Component({
  selector: 'gen-curation-match-found',
  templateUrl: './curation-match-found.component.html',
  styleUrls: ['./curation-match-found.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CurationMatchFoundComponent implements OnInit {
  public curationItem: ICurationItem;
  public payload: any;
  public tunnel$: Subject<any>;
  public callback: (model) => Observable<Response>;
  public statusText: string;
  public status: string;
  public itemKey: string;
  public disease: string;
  public lastModificationDate: string;
  public itemType: string;
  public curationTier: string;
  public curationType: string;
  public curationItemName: string;

  constructor(private datePipe: DatePipe) {
  }

  ngOnInit() {
    this.tunnel$.asObservable().filter(value => value.emitter !== 'child').subscribe(next => {
      next.value && this.submit(this.payload);
    });
    this.curationItem = this.payload.itemData;
    this.curationType = this.payload.curationType;
    this.curationItemName = this.payload.curationItemName;
    if (this.curationType === CurationSettings.CURATION_ABERRATION) {
      this.initAberrationData();
    }
    else {
      this.initCurationData();
    }
    // this.status = CurationUtils.getCurationStatusDisplayString(this.curationItem.status);
    // this.disease = this.curationItem.diseaseDisplay;
    // this.itemType = this.curationItem.aberration.AberrationClass;
    // this.itemKey = this.curationItem.metadata['aberrationKey'];
    // this.curationTier = this.curationItem.curationData ?  this.curationItem.curationData['tier'] ? this.curationItem.curationData['tier'] : '' : ''
    // this.lastModificationDate = (<any>new Date(this.curationItem.curationData['meta']['lastUpdated'])).toPlatformFormat();
  }

  submit(model) {
    this.callback(model)
      .subscribe((model) => {
        this.tunnel$.next({ emitter: 'child', value: model});
      });
  }

  initAberrationData() {
    this.curationItem = this.payload.itemData;
    this.status = this.curationItem['opinion']['to']; // Status is saved in 'to' field of opinion
    this.statusText = CurationUtils.getCurationStatusDisplayString(this.status);
    this.disease = this.curationItem.diseaseDisplay;
    this.itemType = this.curationItem.aberration.AberrationClass;
    this.itemKey = this.curationItem.metadata['aberrationKey'];
    this.curationTier = this.curationItem.curationData ?  this.curationItem.curationData['tier'] ? this.curationItem.curationData['tier'] : '' : '';
    this.lastModificationDate = (<any> new Date(this.curationItem.curationData['meta']['lastUpdated'])).toPlatformFormat();
  }

  initCurationData() {
    this.curationItem = this.payload.itemData;
    this.status = this.curationItem['opinion']['to'];
    this.statusText = CurationUtils.getCurationStatusDisplayString(this.status);
    this.disease = this.curationItem['curationData']['content']['diseaseDisplay'];
    const type = this.curationItem['curationItem']['type'];
    // this.itemType = type.charAt(0).toUpperCase() + type.slice(1);
    this.itemType = this.curationItemName;
    this.itemKey = this.curationItem['curationData']['content']['title'];
    this.curationTier = this.curationItem.curationData ?  this.curationItem.curationData['tier'] ? this.curationItem.curationData['tier'] : '' : '';
    // this.lastModificationDate =  (<any> new Date(this.curationItem.curationData['meta']['lastUpdated'])).toPlatformFormat();
    this.lastModificationDate = this.datePipe.transform(this.curationItem.curationData['meta']['lastUpdated'],"d MMM y");
  }

}
